module.exports = __webpack_public_path__ + "img/patent_image10.4e04510f.png";